// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Wn7S","options":"AnswerScale_options__Vli-e","selected":"AnswerScale_selected__3j2jr"};